import * as next from '../../../types/next'
import { CONTROL_NAME } from '../../../utils/blocks/types'
import type { UpBlockHandler } from '../types'

import { upCommonSettings } from './common'

/**
 * Note: Although the previous block type was named "Label", it is referred to
 * as paragraph in the Journey Builder UI, therefore we are renaming it now.
 *
 * Later: Consider migrating text to plain html instead of encoded strings
 */
export const up: UpBlockHandler<next.ParagraphBlock> = (uischema) => {
  if (uischema.type !== CONTROL_NAME.LABEL_CONTROL) {
    throw new Error('Expected a valid Paragraph control')
  }

  return {
    type: next.BLOCK_TYPE.PARAGRAPH,
    settings: {
      ...upCommonSettings(uischema),
      text: uischema.text?.trim() ?? null
    }
  }
}
